import * as React from "react";
import {getTranslation} from "../../utils/translationUtil";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";

export interface IHomeResourceCardProps {
    path: string;
    testIdPrefix: string;
    iconClass: string;
    iconModifier: string;
    titleKey: string;
    titleDefault: string;
    descriptionKey: string;
    descriptionDefault: string;
}

export const HomeResourceCard: React.FunctionComponent<IHomeResourceCardProps> = (props) => {
    const navigate = useNavigate();
    const goToPath = () => navigateTo(props.path, navigate);

    return (
        <div
            className="home__resource-card"
            onClick={goToPath}
            data-testid={`${props.testIdPrefix}__container`}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    goToPath();
                }
            }}
        >
            <div className="home__resource-card-header">
                <div className={`home__resource-card-icon ${props.iconModifier}`}>
                    <i className={props.iconClass} />
                </div>
                <h3 className="home__resource-card-title" data-testid={`${props.testIdPrefix}__title`}>
                    {getTranslation(props.titleKey, props.titleDefault)}
                </h3>
            </div>
            <p className="home__resource-card-description">
                {getTranslation(props.descriptionKey, props.descriptionDefault)}
            </p>
        </div>
    );
};
